'use client';

import React, { FC } from 'react';
import { InventoryStatusCode } from '@/lib/shopify';
import { Button } from '@/components';
import useProductContext from '@/context/ProductContext';
import { TypeProduct } from '@/core/generated-types';
import { useProductValidations } from '@/hooks/useProductValidations';
import { CTA_COLORS } from '../types';
import { getCTAStyles } from '@/components/utils';

interface AddButtonProps {
  inventoryStatus: InventoryStatusCode | null;
  onClick?: () => void;
  isSelected?: boolean;
  product?: TypeProduct | null;
}

const AddButton: FC<AddButtonProps> = ({
  inventoryStatus,
  onClick,
  isSelected = false,
  product,
}) => {
  const { inventoryStatusCopy } = useProductContext();
  const ctaColor = CTA_COLORS.DEFAULT;
  const isValidProduct = useProductValidations(product);

  let buttonText = '';
  let buttonClasses = '';
  let isDisabled = !isValidProduct;

  switch (inventoryStatus) {
    default: {
      buttonText = isSelected
        ? 'Added to Order'
        : inventoryStatusCopy?.availableCta || 'Add to Cart';
      buttonClasses = getCTAStyles(ctaColor);
      break;
    }
    case InventoryStatusCode.OUT_OF_STOCK: {
      buttonText = inventoryStatusCopy?.outOfStockCta || 'Out of Stock';
      isDisabled = true;
      break;
    }
    case InventoryStatusCode.PRESALE: {
      buttonText = inventoryStatusCopy?.preSaleCta || 'Pre-Order Now';
      break;
    }
  }

  if (isDisabled) {
    buttonClasses = 'bg-grey-midtone border-grey-midtone';
  }

  return (
    <Button
      type="submit"
      ctaText={buttonText}
      fullWidth={true}
      classes={`btn-responsive ${buttonClasses}`}
      disabled={isDisabled || isSelected}
      onClick={onClick}
    />
  );
};

export default AddButton;
